// extracted by mini-css-extract-plugin
export default {"Wrapper":"Feed_Wrapper__w+P-3","followText":"Feed_followText__tOaMP"};